<template>
  <span>
    <v-dialog persistent v-model="dialog" width="50%">
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <slot />
        </span>
      </template>
      <v-form
        ref="form"
        v-model="form.valid"
        lazy-validation
        @submit.prevent="onSubmit"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            <span>Add IP Address</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <a href="#" @click="getRequestClientIP">{{ linkText }}</a>
            <v-text-field
              v-model="form.fields.ip"
              label="Ip Address"
              :rules="form.rules.ip"
              :disabled="edit"
              required
            ></v-text-field>
            <v-text-field
              v-model="form.fields.comment"
              label="Comment"
              :rules="form.rules.comment"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" color="primary" :disabled="!form.valid">
              Submit
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="dialog = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </span>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('atlasadmin');

import { requiredRule, minLengthRule, isIpAddress } from '@/utils/rules.js';
import atlasAdminService from "@/services/atlasadmin";
export default {
  name: 'AddIpForm',
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    comment: {
      type: String,
      require: true,
      default: ''
    },
    ip: {
      type: String,
      require: true,
      default: ''
    }
  },
  watch: {
    comment(val) {
      this.form.fields.comment = val;
    },
    ip(val) {
      this.form.fields.ip = val;
    }
  },
  data() {
    return {
      linkText: '',
      requestClientIP: '',
      form: {
        valid: false,
        fields: {
          comment: this.comment,
          ip: this.ip
        },
        rules: {
          comment: [requiredRule(), minLengthRule(3)],
          ip: [requiredRule(), isIpAddress()]
        }
      },
      dialog: false
    };
  },
  async mounted() {
    this.requestClientIP = await atlasAdminService.getRequestClientIP();
    this.linkText =
      'Use my current client IP address ( ' + this.requestClientIP + ' )';
  },
  methods: {
    ...mapActions(['addIp']),
    async onSubmit() {
      await this.addIp({ ...this.form.fields });
      this.dialog = false;
    },
    async getRequestClientIP(){
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      this.ip = this.requestClientIP;
      this.comment =`${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
    }
  }
};
</script>
